import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { DataService_AcademySetup } from "./shared/data.service";
import { UserService } from "../../../shared";
import * as moment from "moment";

//INSERT POPUP IMPORTS
import { SchoolAddAcademyComponent } from "./school-add-academy/school-add-academy.component";
import { SchoolEditAcademyComponent } from "./school-edit-academy/school-edit-academy.component";
import { SchoolService } from "../../../shared/services/school.service";
import { ConfirmationService } from "primeng/api";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";

@Component({
	selector: "caass-academy-setup",
	templateUrl: "./academy-setup.component.html",
	styleUrls: ["./academy-setup.component.css"],
})
export class AcademySetupComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private AcademySetupService: DataService_AcademySetup,
		private dialogService: DialogService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadSchoolist();
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;

	SchoolID: any;
	lstSchool: any = [];

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedAcademy: any;
	lstAcademy: any = [];

	//Filter lists
	lstDirector_PersonName: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "AcademyDesc", header: "Name" },
		{ field: "AcademyCD", header: "Abbreviation" },
		{ field: "Director_PersonName", header: "Administrator" },
		{ field: "TardyTimeDesc", header: "Tardy Time" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.SchoolID = this.lstSchool[0].SchoolID;

				this.loadAcademy();
			},
			(error) => {}
		);
	}

	loadAcademy() {
		this.loading = true;

		var result = this.AcademySetupService.LoadAcademy(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstAcademy = response;

				for (var i = 0; i < this.lstAcademy.length; i++) {
					var next = this.lstAcademy[i];

					next.TardyTimeDesc = moment(new Date(next.TardyTime)).format("h:mm:ss a");
				}

				//Load Data Filter Lists
				this.lstDirector_PersonName = Array.from(new Set(this.lstAcademy.map((item: any) => item.Director_PersonName))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadAcademy();
	}

	//Custom Button Methods
	onAddAcademy() {
		this.errorMessage = "";

		var ref = this.dialogService.open(SchoolAddAcademyComponent, {
			header: "Add Academy",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SchoolID: this.SchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadAcademy();
			}
		});
	}

	onEditAcademy() {
		this.errorMessage = "";

		if (this.SelectedAcademy == undefined) {
			this.errorMessage = "Select an academy to edit";
			return;
		}

		var ref = this.dialogService.open(SchoolEditAcademyComponent, {
			header: "Edit Academy",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SchoolID: this.SchoolID,
				SelectedAcademy: this.SelectedAcademy,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadAcademy();
			}
		});
	}

	onDeleteAcademy() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedAcademy == undefined) {
			this.errorMessage = "Select an academy to delete";
			return;
		}

		this.confirmationService.confirm({
			key: "main",
			acceptLabel: "Yes",
			rejectVisible: true,
			rejectLabel: "No",
			message: "Deleting this academy will also delete all of its homerooms. Do you want to continue?",
			header: "Delete Academy",
			icon: "fa",
			accept: () => {
				this.FinishDelete();
			},
			reject: () => {},
		});
	}

	FinishDelete() {
		//Call SP
		var result = this.AcademySetupService.DeleteAcademy(this.SelectedAcademy.AcademyID);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadAcademy();
				} else {
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the Academy",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onSchoolChange(val) {
		this.SchoolID = val;

		this.loadAcademy();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedAcademy = val.data;
	}
	onRowUnselect(val) {
		this.SelectedAcademy = null;
	}
	onRowDblClick(Academy) {
		this.SelectedAcademy = Academy;
		this.onEditAcademy();
	}
	////////////////////////////////////////////
}
